module.exports = __webpack_public_path__ + "74f6c3d3ba317a87cb069bb5b85cd369.gif";